import { 
  AUTH_USER, 
  UNAUTH_USER, 
  AUTH_ERROR, 
  FILL_SIGNIN_EMAIL 
} from '../actions/types';

export default (state = {}, action) => {
  switch(action.type) {
    case AUTH_USER:
      return { 
        ...state, 
        authenticated: true 
      };
    case UNAUTH_USER:
      return { 
        ...state, 
        authenticated: false 
      };
    case AUTH_ERROR:
      return { 
        ...state, 
        errorMessage: action.payload 
      };
    case FILL_SIGNIN_EMAIL:
      return {
        ...state,
        fillSignInEmail: action.payload
      };
    default: 
      return state;
  }
}